import ReactDOM from "react-dom";
import { OwcBackdrop, OwcProgressSpinner } from "@one/react";
import { BACKDROP_ZINDEX } from "../../constants";

const BackdropPortal = ({
  show,
  opacity = 0.3,
  zIndex = BACKDROP_ZINDEX,
  spinnerSize = "medium",
  message,
  children,
}) => {
  if (!show) return null;

  const backdropContent = (
    <OwcBackdrop opacity={opacity} style={{ zIndex }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
        {children || <OwcProgressSpinner size={spinnerSize} />}
        {message && (
          <span style={{ color: "var(--one-color-interaction-default-brand-1)", fontSize: 14, fontWeight: 500 }}>
            {message}
          </span>
        )}
      </div>
    </OwcBackdrop>
  );

  return ReactDOM.createPortal(backdropContent, document.body);
};

export default BackdropPortal;
